module.exports = "pegasus/assets/hexline-twitter.png";